import { Flex, Input, Button, Grid } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

export function AbraMidiaViewHomePage() {
  const navigate = useNavigate()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const code = event.currentTarget.code.value
    navigate(`/abra-midia/visualizar/${code}`)
  }

  return (
    <Flex w="100%" h="100vh" align="center" justify="center">
      <form onSubmit={handleSubmit}>
        <Grid templateColumns="1fr auto" alignItems="center">
          <Input
            type="text"
            name="code"
            placeholder="Código do ABRA mídia"
            borderTopRightRadius={0}
            borderBottomRightRadius={0}
          />
          <Button type="submit" borderTopLeftRadius={0} borderBottomLeftRadius={0}>
            Visualizar
          </Button>
        </Grid>
      </form>
    </Flex>
  )
}
